export default __webpack_public_path__ + "static/media/back_prizes.9c61bd8b.png";